// src/services/api.ts
import axios from 'axios';

const api = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}/api`,
  timeout: Number(import.meta.env.VITE_API_TIMEOUT_MS ?? 30000),
  withCredentials: import.meta.env.VITE_API_WITH_CREDENTIALS === 'true',
});

/* ===== Interceptor para token ===== */
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/* ===== Respuesta limpia ===== */
api.interceptors.response.use(
  (res) => res.data,
  (error) => {
    return Promise.reject(error?.response?.data ?? error);
  }
);

export default api;
